import {
  ConfirmUserAccountDto,
  IUser,
  LoginDto,
  LoginMagicLinkDto,
  ResetPasswordDto,
  SendConfirmationResetDto,
  SendMagicLinkDto,
  SendPasswordResetDto,
} from 'admiral-core';
import axios, { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class AuthApi {
  static login(loginDto: LoginDto): Promise<AxiosResponse<IUser>> {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/auth/login`,
      data: loginDto,
    });
  }

  static loginWithMagicLink(loginMagicLinkDto: LoginMagicLinkDto): Promise<AxiosResponse<IUser>> {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/auth/login-with-magic-link`,
      data: loginMagicLinkDto,
    });
  }

  static sendMagicLink(sendMagicLinkDto: SendMagicLinkDto): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/auth/send-magic-link`,
      data: sendMagicLinkDto,
    });
  }

  static sendPasswordReset(
    sendPasswordResetDto: SendPasswordResetDto,
  ): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/auth/send-password-reset`,
      data: sendPasswordResetDto,
    });
  }

  static sendConfirmationReset(
    sendConfirmationResetDto: SendConfirmationResetDto,
  ): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/auth/send-confirmation-reset`,
      data: sendConfirmationResetDto,
    });
  }

  static resetPassword(resetPasswordDto: ResetPasswordDto): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/auth/reset-password`,
      data: resetPasswordDto,
    });
  }

  static confirmAccount(confirmUserAccountDto: ConfirmUserAccountDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/auth/confirm`,
      data: confirmUserAccountDto,
    });
  }

  static getConfirmationAccount(code: string): Promise<AxiosResponse<IUser>> {
    return AdmiralApi.apiCall<IUser>({
      method: 'POST',
      url: `${BASE_URL}/auth/get-confirmation-account`,
      data: {
        code: code,
      },
    });
  }

  static sendConfirmationEmail(email: string): Promise<AxiosResponse> {
    return axios.post(`${BASE_URL}/auth/send-confirmation-email`, { email });
  }
}
